export const initialState = {
  company: {
    tradeDbaName: '',
    legalName: '',
    parentCompany: ''
  },
  deliveryDetails: {
    receivingPlantContactName: '',
    receivingPlantPhoneNumber: '',
    afterHoursContactName: '',
    afterHoursPhoneNumber: '',
    warehouseRecivingHours: '',
    appointmentRequired: false
  },
  invoiceDelivery: {
    email: [],
    fax: '',
    mailToBillTo: false
  },
  deliveryInstructions: {
    shippingInstructions: '',
    customsText: '',
    loadingInstructions: '',
    unloadingInstructions: '',
    billOfLandingText: ''
  },
  address: {
    requestType: null,
    legalName: '',
    tradeDbaName: null,
    coName: null,
    country: null,
    street: null,
    city: null,
    state: null,
    zipCode: null,
    poBox: null,
    taxNumber1: null,
    taxNumber2: null,
    taxNumber3: null,
    taxExempt: false,
    dnbNumber: null,
    useSoldTo: false,
    useBillTo: false,
    usePayer: false,
    naturalPerson: false,
    district: null,
    zonaFranca: null,
    taxType: null,
    fiscalId: null,
    icmsTaxPayer: null,
    suframa: null,
    email: [],
    telephone1: null,
    telephone2: null
  },
  coa: {
    sameAsInvoiceDelivery: false,
    email: [],
    fax: ''
  },
  packingList: {
    sameAsInvoiceDelivery: false,
    sameAsCoa: false,
    email: [],
    fax: ''
  },
  orderConfirmation: {
    sameAsInvoiceDelivery: false,
    sameAsCoa: false,
    sameAsPackingList: false,
    email: [],
    fax: ''
  },
  accountPayable: {
    name: '',
    title: '',
    email: '',
    phoneNumber: ''
  },
  bankReference: {
    name: '',
    routingNumber: '',
    accountNumber: '',
    country: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    faxNumber: '',
    clabe: ''
  },
  bankerContact: {
    contactName: '',
    phoneNumber: '',
    email: ''
  },
  soldTo: {
    address: {
      street: '',
      city: '',
      country: '',
      state: '',
      zipCode: '',
      useSoldTo: false,
      useBillTo: false,
      usePayer: false,
      taxExempt: false,
      taxNumber1: '',
      dnbNumber: ''
    }
  },
  billTo: {
    address: {
      street: '',
      city: '',
      country: '',
      state: '',
      zipCode: '',
      useSoldTo: false,
      useBillTo: false,
      tradeDbaName: '',
      legalName: '',
      coName: '',
      usePayer: false
    },
    invoiceDelivery: {
      email: [],
      fax: '',
      mailToBillTo: false
    }
  },
  payer: {
    address: {
      street: '',
      city: '',
      country: '',
      state: '',
      zipCode: '',
      useSoldTo: false,
      useBillTo: false,
      usePayer: false,
      tradeDbaName: '',
      legalName: '',
      taxNumber1: '',
      dnbNumber: ''
    }
  },
  shipTo: [
    {
      deliveryDetails: {
        receivingPlantContactName: '',
        receivingPlantPhoneNumber: '',
        afterHoursContactName: '',
        afterHoursPhoneNumber: '',
        warehouseRecivingHours: '',
        appointmentRequired: false
      },
      invoiceDelivery: {
        email: [],
        fax: '',
        mailToBillTo: false
      },
      deliveryInstructions: {
        shippingInstructions: '',
        customsText: '',
        loadingInstructions: '',
        unloadingInstructions: '',
        billOfLandingText: ''
      },
      address: {
        street: '',
        city: '',
        country: '',
        state: '',
        zipCode: '',
        useSoldTo: false,
        useBillTo: false,
        usePayer: false,
        tradeDbaName: '',
        legalName: '',
        taxExempt: false,
        dnbNumber: ''
      },
      coa: {
        sameAsInvoiceDelivery: false,
        email: [],
        fax: ''
      },
      packingList: {
        sameAsInvoiceDelivery: false,
        sameAsCoa: false,
        email: [],
        fax: ''
      },
      orderConfirmation: {
        sameAsInvoiceDelivery: false,
        sameAsCoa: false,
        sameAsPackingList: false,
        email: [],
        fax: ''
      }
    }
  ],
  customer: {
    region: 'na',
    submittedDate: 'January 14',
    modifiedDate: 'January 14',
    expectedDate: 'January 14'
  },
  customerOptoutAttachments: false,
  lineOfCredit: false
};
